<script>
    import { onMount } from "svelte";
    import Select from "svelte-select/Select.svelte";
    import { apiMethods } from "../../../Services/index.svelte";
    import TableToggle from "../../../Components/Common/TableToggle.svelte";
    import {
        showError, getText
    } from "../../../Utils/utilFunctions.svelte";

    import { NotificationModal, SvelteTable } from "../../../Components/Common/index.svelte";

    export let providerDetails = {},
        isModalOpen = false,
        reload = () => {},
        accountId,
        accountGroupId,
        isAdd = false;

    let previousKeyDown;

    let selectedHospital,
        noGapHospitals = [],
        hospitalNoGapPrograms = [],
        providerNoGapPrograms = [],
        isLoadingHospitals = false,
        isLoadingHospitalNoGapPrograms = false;

    $: columns = [
        {
            key: "fundId",
            title: "Insurance Fund",
            headerClass: `text-left pl-4 w-3/3`,
            class: "text-left pl-4 cursor-default align-middle",
            renderValue: (v) => getText(v.fundName, "-"),
        },
       /*  {
            key: "surgeon",
            title: "Surgeons",
            headerClass: "text-left w-1/3 pl-4 cursor-default",
            class: "text-left pl-4 cursor-default align-middle ",
            renderValue: (v) => v.isAllProviders ? "All surgeons" : 
                v.hospitalsNoGapProgramProviders.length > 0 ? 
                    v.hospitalsNoGapProgramProviders.map(i => i.providerName).join(", ") : "No surgeons selected"
        },
        {
            key: "details",
            title: "Details",
            headerClass: "text-left w-1/3 pl-4 cursor-default",
            class: "text-left pl-4 cursor-default align-middle ",
            renderValue: (v) =>  _renderNoGapProgramDetails(v)
        }, */
        {
            key: "isNoGapProgramParticipant",
            title: "Participate",
            headerClass: "text-left pl-4 text-[14px] text-center",
            class: (v) =>
                `text-left pl-4 text-[14px] cursor-auto flex items-center justify-center`,
            renderComponent: {
                component: TableToggle,
                props: {
                    valueKey: "isActive",
                    clickFunction: async (rowData) => {
                        if(rowData.isActive){
                            //delete
                            var providerNoGapProgram = providerNoGapPrograms.find(p => p.hospitalNoGapProgramId == rowData.id);
                            if(!providerNoGapProgram) return;
                            await apiMethods.deleteMethod
                            .deleteAccountProviderNoGapProgram(providerNoGapProgram.id)
                            .then((res) => {
                                if (!res || res.error)
                                    showError(
                                        res.error ??
                                            `Failed to activate selected gap program for this provider.`,
                                    );
                                else{
                                    loadDoctorProviderNoGapPrograms();
                                }
                            })
                            .catch((err) => showError(err));  
                        } else {
                            //create
                            await apiMethods.postMethod
                            .addAccountProviderNoGapProgram({
                                doctorId: providerDetails.doctorId,
                                doctorProviderId: providerDetails.id,
                                hospitalNoGapProgramId: rowData.id
                            })
                            .then((res) => {
                                if (!res || res.error)
                                    showError(
                                        res.error ??
                                            `Failed to activate selected gap program for this provider.`,
                                    );
                                else
                                    loadDoctorProviderNoGapPrograms();
                            })
                            .catch((err) => showError(err)); 
                        }
                         
                    },
                },
            },
        },
    ];

    const _renderNoGapProgramDetails = (v) =>
    {
        var specialRulesText = "No special rules";
        if(v.hospitalsNoGapProgramSpecialRule && v.hospitalsNoGapProgramSpecialRule.length > 0) {
            let groupedRules = groupRules(v.hospitalsNoGapProgramSpecialRule);
            specialRulesText = groupedRules.map(r => getRuleDescription(r)).join(", ");
        } 

        var defaultRuleText = getDefaultRuleDescription(v);

        return `<div class="flex flex-1 flex-col justify-start gap-y-2">
                    <div class="w-full">
                        <b>Special Rules:</b>
                        <span>${specialRulesText}</span>
                    </div>
                    <div>
                        <b>Default Rule:</b>
                        <span>${defaultRuleText}</span>
                    </div>
                     <div>
                        <b>Uplift invoice:</b>
                        <span>${v.isUpliftInvoice ? `Yes (${getText(v.upliftInvoiceEmail, "")})` : "No"}</span>
                    </div>
                </div>
        `;
    }

    onMount(async () => {
       
    });

    $: if (isModalOpen) {
        loadNoGapProgramHospitals();
        loadDoctorProviderNoGapPrograms();
    } else {
        selectedHospital = null;
    }

    // HELPER FUNCTIONS

    const closeModal = () => {
        isModalOpen = false;
        providerDetails = {};
        providerNoGapPrograms = [];
        noGapHospitals = [];
        document.onkeydown = previousKeyDown;
    };

    const loadNoGapProgramHospitals = async () => {
        isLoadingHospitals = true;

        await apiMethods.getMethod
            .getHospitals(0, 999999, { 
                "filter[isNoGapProgram]": true
            })
            .then((res) => {
                if (!res.error) noGapHospitals = res.results;
                else noGapHospitals = [];
            });

        isLoadingHospitals = false;
    };

    const loadDoctorProviderNoGapPrograms = async () => {
        await apiMethods.getMethod
            .getAccountProviderNoGapPrograms(providerDetails.doctorId, providerDetails.id)
            .then((res) => { 
                if (!res.error) providerNoGapPrograms = res.results;
                else providerNoGapPrograms = []; 
                if(hospitalNoGapPrograms.length > 0) {
                    hospitalNoGapPrograms = [...hospitalNoGapPrograms.map(r => (
                        {
                            ...r,
                            isActive: providerNoGapPrograms.map(h => h.hospitalNoGapProgramId).includes(r.id)
                        }
                    ))];
                }
            });

    };

    const loadHospitalNoGapPrograms = async () => {
        isLoadingHospitalNoGapPrograms = true;
        hospitalNoGapPrograms = [];

        await apiMethods.getMethod
            .getHospitalsNoGapProgram(0, 99999, {
                "filter[hospitalId]": selectedHospital.id
            })
            .then((res) => {
                _handleNoGapProgramsResponse(res);
            })

        isLoadingHospitalNoGapPrograms = false;
    }

    const _handleNoGapProgramsResponse = (res) => {
        if (!res || res.error)
            showError(
                res.error ??
                    `Failed to load existing No-Gap Programs ${defaultErrorMsgPrompt}`,
            );
        else {
            hospitalNoGapPrograms = [...res.results.map(r => (
                {
                    ...r,
                    isActive: providerNoGapPrograms.map(h => h.hospitalNoGapProgramId).includes(r.id)
                }
            ))];
        }
    };

    const groupRules = (data) => {
        return Object.values(data.reduce((acc, item) => {
            let key;

            if (item.rebateType === 1) {
                key = `type1-${item.unitValue}`;
            } else {
                key = `type0-${item.upliftRebate}`;
            }

            if (!acc[key]) {
                acc[key] = {
                    hospitalNoGapId: item.hospitalNoGapId,
                    rebateType: item.rebateType,
                    unitValue: item.unitValue,
                    upliftRebate: item.upliftRebate,
                    error: item.error ?? null,
                    itemNums: []
                };
            }

            acc[key].itemNums.push(item.itemNum);
            return acc;
        }, {}));
    }

    const getRuleDescription = (ruleGroup) => {
        return `${ruleGroup.rebateType == 0 ? 'Uplift with' : 'Unit value of'} ${ruleGroup.rebateType == 0 ? `${ruleGroup.upliftRebate}` : `$${ruleGroup.unitValue}`} (${ruleGroup.itemNums.map(i => i).join(", ")})`;
    }

    const getDefaultRuleDescription = (noGapProgram) => {
        return `${noGapProgram.rebateType == 0 ? 'Uplift' : 'Unit value of'} ${noGapProgram.rebateType == 0 ? `(${noGapProgram.upliftRebate})` : `$${noGapProgram.unitValue} Fallback: ${noGapProgram.fallBackRebate}`}`;
    }

</script>

<NotificationModal
    {isModalOpen}
    title={`Provider No Gap Program Participating Funds`}
    modalMaxWidth="max-w-[1000px]"
    cancelText="Close"
    showConfirmBtn={false}
    {closeModal}
    closeModalFunction={closeModal}
    noContentPadding
>
    <div class="flex flex-1 flex-col gap-y-4 relative overflow-y-auto p-6">
        <div class="w-full rounded-md mt-2" id="selectedHospital">
            <Select
                bind:value={selectedHospital}
                items={noGapHospitals}
                itemId="id"
                label="name"
                on:clear={(ev) => { selectedHospital = null }}
                on:change={(ev) => {
                    loadHospitalNoGapPrograms();
                }}
                noOptionsMessage="No hospital found"
                placeholder="Select hospital"
            />
            {#if selectedHospital == null}
                <div class="w-full flex items-center justify-center h-[400px] rounded-md mt-2">
                    Please select a hospital
                </div>
            {/if}
            {#if selectedHospital != null}
                    {#if isLoadingHospitalNoGapPrograms}
                        <div class="w-full flex items-center justify-center h-[400px] rounded-md mt-2">
                            <div class="flex my-12 flex-1 justify-center">
                                <progress class="progress progress-primary w-56" />
                            </div>
                        </div>
                    {:else}
                        <div class="w-full flex h-[400px] mt-2">
                            {#if hospitalNoGapPrograms.length > 0}
                                <div class="w-full overflow-auto pr-2">
                                    <SvelteTable
                                        columns={columns.filter((col) => !col.isHidden)}
                                        rows={hospitalNoGapPrograms}
                                        clickCellFunc={({ detail: { event, row, key } }) => {
                                            //handleClickCell(event, row, key);
                                        }}
                                        clickColFunc={({ detail: { event, row, key } }) => {
                                            //handleClickCol(event, row, key);
                                        }}
                                    />
                                </div>
                            {:else}
                                <div class="w-full flex items-center justify-center rounded-md mt-2">
                                        No Gap Programs defined for selected hospital
                                </div>
                            {/if}
                        </div>
                    {/if}
            {/if}
        </div>
    </div>
</NotificationModal>

<style>
    
</style>
